import axios from 'axios'
import store from '@/store'

async function signUp(payload, cnpj = false) {
    try {
        store.commit('user/setLoading', true)
        const result = await axios.post(`${process.env.VUE_APP_ROOT_API}/clients/v1/users/signup${cnpj ? '/cnpj' : ''}`,
            payload,
        )
        store.commit('user/setLoading', false)

        return result.data
    } catch (error) {
        store.commit('user/setLoading', false)
        return error.response.data
    }
}

export default signUp